module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "z-textarea",
    class: {
      'focus': _vm.focus, 'no-label': (_vm.$props.label ? false : true), 'is-dirty': _vm.isDirty, 'has-value': (_vm.value || _vm.value === 0), 'has-error': _vm.error && _vm.error.length, 'disabled': _vm.$props.disabled, 'readonly': _vm.$props.readonly, 'inline': _vm.$props.inline, 'border': _vm.$props.border, 'no-margin': _vm.$props.noMargin
    }
  }, [_c('div', {
    staticClass: "z-textarea-container"
  }, [(_vm.$props.label) ? _c('label', {
    attrs: {
      "for": _vm.$props.id
    },
    domProps: {
      "innerHTML": _vm._s((_vm.$props.label + ((_vm.$props.required) ? '*' : '') + (_vm.$props.readonly ? ' (только для чтения)' : '') + (_vm.$props.loading ? ' (загрузка)' : '')))
    }
  }) : _vm._e(), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    attrs: {
      "placeholder": _vm.$props.placeholder,
      "type": _vm.$props.type,
      "id": _vm.$props.id,
      "name": _vm.$props.name,
      "required": _vm.$props.required,
      "disabled": _vm.$props.disabled,
      "readonly": _vm.$props.readonly,
      "autocomplete": _vm.$props.autocomplete,
      "minlength": _vm.$props.minlength,
      "maxlength": _vm.$props.maxlength
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "keyup": _vm.onKeyUp,
      "keypress": _vm.onKeyPress,
      "paste": _vm.onPaste,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }
    }
  }), _c('div', {
    ref: "shadow",
    staticClass: "shadow-height"
  }, [_vm._v(_vm._s(_vm.val))])]), _c('div', {
    staticClass: "progress-bar-container"
  }, [_c('md-progress-bar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$props.loading),
      expression: "$props.loading"
    }],
    staticClass: "progress-bar",
    attrs: {
      "md-mode": "indeterminate"
    }
  })], 1), _vm._t("default"), (_vm.error) ? _c('span', {
    staticClass: "z-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fe67bbc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ZTextArea.vue
// module id = 1064
// module chunks = 0